import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import Card from "../../../components/common/Card.js";
import CardHeader from "../../../components/common/CardHeader.js";
import CardBody from "../../../components/common/CardBody.js";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { CountryService } from "../../../service/settings/manage/country.service.js";
import { ProvinceService } from "../../../service/settings/manage/province.service.js";
import { CityService } from "../../../service/settings/manage/city.service.js";
import { GenderService } from "../../../service/settings/manage/gender.service.js";
import { IdTypeService } from "../../../service/settings/manage/id_type.service.js";
import { StatusTypesService } from "../../../service/settings/manage/status_type.service.js";
import { StatusService } from '../../../service/settings/manage/status.service.js';
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import { history } from "../../../helper/history.js";
import debounce from "lodash.debounce";
import { UserManagementService } from "../../../service/user_management/user_management.service.js";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  IconButton
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { routes } from "../../../helper/routes.js";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import sweetAlert, {
  sweetStatusAlert,
} from "../../../components/common/SweetAlert.js";
import { TeacherService } from "../../../service/manage/registration/teacher.service.js";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import {  roleService } from "../../../service/user_management/role.service.js";
import {  StaffService } from "../../../service/user_management/staff.service.js";
import AddTeacherModal from "../dashboard/AddTeacherModal";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { roleTypeConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

export default class ManageTeacher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      teachers: [],
      first_name: "",
      last_name: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      role_code_selected: "",
      status_id: "",
      created_on: "",
      created_by: "",
      genders: [],
      employeeTypes: [],
      titles: [],
      countries: [],
      provinces: [],
      cities: [],
      adm_statuses: [],
      statusTypes: [],
      idTypes: [],
      idValue: null,
      AdmStatustype: "Availability",
      showInsertModal: false,
      isLoading: false,
      isTableDataLoading: true,
      limit: 10, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      totalTeachers: 10,
      currentPage: 0,
      isModified: false,
      isAddressesLoading: false,
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      sortColumn: "user_code", // Default sort column
      sortDirection: "desc",
      errorProvince: [],
      errorCity: [],
      addressValidity: [],
      hidden: false,
      node_mid: null,
      user_list_table_id: null,
      session_adm_id: null,
      country_id: "",
      province_id: "",
      city_id: "",
      address_1: "",
      address_2: "",
      postalcode: "",
      user_id: "",
      is_lg_user:"",
      user_name:"",
      breadcrumb2:null,
      nodeTitle:null,
      main_table_id:null,
      user_code:"",
      showPrivModel:false,
      roles: [],
      role_code:null,
      assignedRoles:[],      
      privilegedTeacher:null,
      isAddTeacherModalOpen:false,
      isPrivilegeModalLoading:false,
      isModalLoading:false
    };
    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllTeachers, 2000);

    this.createValidationsInstance();
    this.formInitialState = {
      first_name: "",
      last_name: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      role_code_selected: "",
      status_id: "",
      created_on: "",
      created_by: "",
      postalcode: "",
    };
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        address: {
          message: "The :attribute must be a valid address",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
              params.indexOf(val) === -1
            );
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
        },
        dateBefore: {
          message: "The :attribute must be before current date",
          rule: (val, params, validator) => {
            const currentDate = new Date().toISOString().split("T");
            return val < currentDate[0];
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        phone_number: {
          message: "The :attribute must be a valid phone number",
          rule: (val, params, validator) => {
            const isTenDigitsStartingWithZero =
              val.length === 10 && val.startsWith("0");
            const isNineDigits = val.length === 9 && !val.startsWith("0");
            return isTenDigitsStartingWithZero || isNineDigits;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
      },
    });
    this.updateValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.loadInitialData();
    this.genarateStudentIdPrefix();

    const locationState = this.props.location?.state || {};
    const propsState = this.props.state || {};

    const pendingEmployee = locationState.employee || locationState.teacher || locationState.student || propsState.employee || propsState.teacher || propsState.student;
    const shouldOpenUpdateModal = locationState.openUpdateTeacherModal || locationState.openUpdateEmployeeModal || propsState.openUpdateTeacherModal || propsState.openUpdateEmployeeModal;
    const shouldOpenAssignRoleModal = locationState.openAssignRoleModal || propsState.openAssignRoleModal;

    if (shouldOpenUpdateModal && pendingEmployee) {
      this.toggleUpdateTeacherModal(pendingEmployee);
    } else if (shouldOpenAssignRoleModal && pendingEmployee) {
      this.togglePrivAddition(pendingEmployee);
    }
  }

  componentDidUpdate(prevProps) {
    const prevLocationState = prevProps.location?.state;
    const currentLocationState = this.props.location?.state;

    if (currentLocationState && currentLocationState !== prevLocationState) {
      const pendingEmployee = currentLocationState.employee || currentLocationState.teacher || currentLocationState.student;
      if (currentLocationState.openAssignRoleModal && pendingEmployee && !this.state.showPrivModel) {
        this.togglePrivAddition(pendingEmployee);
      } else if (currentLocationState.openUpdateTeacherModal && pendingEmployee && !this.state.showModal) {
        this.toggleUpdateTeacherModal(pendingEmployee);
      }
    }
  }

  genarateStudentIdPrefix(){
    const id_prefix = this.props.state?.mcode;
    const id_prefix_year = String(new Date().getFullYear() % 100)

    const user_base_prefix = id_prefix+id_prefix_year+"T"

    this.setState({user_code:user_base_prefix})
   
  }

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          // Call the debounced version of fetchStudentData
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  loadInitialData() {
    let privilege_edit = !!this.props.state?.privilege_edit;
    let privilege_add = !!this.props.state?.privilege_add;
    let privilege_delete = !!this.props.state?.privilege_delete;
    this.setState(
      {
        addVisibility: privilege_add,
        editVisibility: privilege_edit,
        deleteVisibility: privilege_delete,
        user_list_table_id: sessionStorage.getItem("table_log_id"),
        session_adm_id: sessionStorage.getItem("manage_user_id"),
        breadcrumb2: this.props.state?.breadcrumb2,
        nodeTitle: this.props.state?.nodeTitle,
        main_table_id: this.props.state?.main_table_id
      },
      () => {
        this.fetchAllTeachers();
        this.getAllGenders();
        this.getAllIdTypes();
        this.getAllEmployeeTypes();
        this.getAllStatusTypes();
        this.getAllContries();
        this.getAllRoles()
      }
    );
  }
  
  getAllRoles(){
    this.setState({isPrivilegeModalLoading:true})
    roleService.getAll().then(res => {
      this.setState({ roles: res.data });   
    })
    this.setState({isPrivilegeModalLoading:false})
  }

  getAllContries() {
    CountryService.getAll().then((res) => {
      this.setState({ countries: res.data });
    });
  }

  getAllGenders() {
    GenderService.getAllGenders().then((res) => {
      this.setState({ genders: res.data });
    });
  }

  getAllIdTypes() {
    IdTypeService.getAllIdTypes().then((res) => {
      this.setState({ idTypes: res.data });
    });
  }

  getAllEmployeeTypes() {
      roleService.getRolesForType({
        "role_user_type_id" : roleTypeConstants.EMPLOYEE.id,
      }).then((res) => {
        this.setState({ employeeTypes: res.data });
      });
    }

  getAllStatusTypes() {
    StatusTypesService.getAll().then((res) => {
      this.setState({ statusTypes: res.data }, ()=>{
        this.getAllStatuses();
      });
    });
  }

  getAllStatuses() {
    const adm_type_id = this.getRespectiveStatusTypeID(
      this.state.AdmStatustype
    );
    StatusService.getByTypeId(adm_type_id).then((res) => {
      this.setState({ adm_statuses: res.data });
    });
  }

  fetchAllTeachers = async () => {
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      user_list_table_id,
      session_adm_id,
    } = this.state;
    const {
      mid,
      owner_restriction,
      lg_user_id,
      lg_user_table_id,
      user_list_restriction,
    } = this.props.state;
    let create_user_id =
      !!owner_restriction && lg_user_id ? lg_user_id : "null";
    let create_user_table_id =
      !!owner_restriction && lg_user_table_id ? lg_user_table_id : "null";
    let user_table_id =
      !!user_list_restriction && user_list_table_id
        ? user_list_table_id
        : "null";
    let user_id =
      !!user_list_restriction && session_adm_id ? session_adm_id : "null";

      await TeacherService.getAll (
      user_id,
      user_table_id,
      create_user_id,
      create_user_table_id,
      mid,
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term
    )
      .then((response) => {
        if (response.success) {
          this.setState({
            teachers: response.data.teachers,
            totalTeachers: response.data.total_count, // Update totalTeachers with the correct count
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching teachers Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching teachers Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSortChange = (sortColumn) => {
    // If the same column is clicked, toggle the sort direction
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllTeachers();
      }
    );
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(this.formInitialState);
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.purgeFields();
      this.validator.hideMessages();
      this.setState(this.formInitialState);
      toggleFunction();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
    if (name === "country_id") {
      const country_id = value;
      this.setState({
        cities: [],
        provinces: [],
        city_id: "",
        province_id: "",
      });
      this.getProvinceForCountry(country_id);
    }
    if (name === "province_id") {
      const province_id = value;
      this.setState({ cities: [], city_id: "" });
      this.getCitiesForProvince(province_id);
    }
  };

  getProvinceForCountry = (country_id) => {
    if (country_id) {
      ProvinceService.getProvinceForCountry(country_id).then((response) => {
        if (response.success) {
          this.setState({ provinces: response.data });
        } else {
          sweetStatusAlert("Failed!", response.message, "error");
        }
      });
    }
  };

  getCitiesForProvince = (province_id) => {
    if (province_id) {
      CityService.getCitiesForProvince(province_id).then((response) => {
        if (response.success) {
          this.setState({ cities: response.data });
        } else {
          sweetStatusAlert("Failed!", response.message, "error");
        }
      });
    }
  };

  togglePrivAddition = async(teacher) => {
    this.setState({isModalLoading:true})
    if(!!teacher){
      const mainTableId = this.state.main_table_id || this.props.state?.main_table_id || this.props.location?.state?.main_table_id || 10;
      await StaffService.searchStaffByTableAndUserIds(teacher?.user_id, mainTableId).then((res) => {
        this.setState(() => ({
          assignedRoles: res.data || [],
        }))
      })
      this.setState(() => ({
        privilegedTeacher: teacher
      }))
    }
    this.setState((prev) => ({
      showPrivModel: !prev.showPrivModel
    }))
    this.setState({isModalLoading:false})
  }

  close = () => {
    this.loadInitialData();
    this.setState((prev) => ({
      showPrivModel:!prev.showPrivModel
    }))
  }

  toggleUpdateTeacherModal = (teacher) => {
    this.setState(
      (prevState) => ({
        showModal: !prevState.showModal,
        first_name: "",
        last_name: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        role_code_selected:"",
        status_id: "",
        created_on: "",
        created_by: "",
        address_1: "",
        address_2: "",
        city_id: "",
        province_id: "",
        postalcode: "",
        country_id: "",
        user_code:"",
        idValue: null,
        idType_id: ""
      }),
      async () => {
        // State has changed, perform your logic here based on the state change
        if (this.state.showModal) {
          this.setState({
            first_name: teacher.first_name,
            last_name: teacher.last_name,
            idValue: teacher?.idValue ? teacher.idValue : null,
            idType_id: teacher?.idType ? teacher.idType : "",
            email: teacher.email,
            phone_number: teacher.phone_number
              ? teacher.phone_number.toString()
              : teacher.phone_number,
            dob: teacher.dob ? teacher.dob : "",
            gender_id: teacher.gender_id ? teacher.gender_id : "",
            role_code: teacher.role_code ? teacher.role_code : "",
            created_on: teacher.created_on ? teacher.created_on : "",
            created_by: teacher.created_by ? teacher.created_by : "",
            status_id: teacher.user_status_id ? teacher.user_status_id : "",
            user_id: teacher.user_id,
            node_mid: teacher.node_mid,
            address_1: teacher.address_1,
            address_2: teacher.address_2,
            city_id: teacher.city_id,
            province_id: teacher.province_id,
            postalcode: teacher.postalcode,
            country_id: teacher.country_id,
            is_lg_user: teacher.is_lg_user,
            user_code:teacher.user_code

          });
          this.getProvinceForCountry(teacher.country_id);
          this.getCitiesForProvince(teacher.province_id);
        }
      }
    );
  };
  
  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      try {
        const {
          user_id,
          first_name,
          last_name,
          email,
          phone_number,
          dob,
          gender_id,
          role_code_selected,
          created_on,
          created_by,
          status_id,
          node_mid,
          country_id,
          province_id,
          city_id,
          address_1,
          address_2,
          postalcode,
          main_table_id,
          user_code,
          idType_id,
          idValue,
        } = this.state;

        const teacherItem = {
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone_number: parseInt(phone_number),
          dob: !!dob ? dob : null,
          gender_id: parseInt(gender_id),
          role_code_selected: role_code_selected,
          created_on: created_on === "" ? null : created_on,
          created_by: created_by,
          user_status_id: parseInt(status_id),
          node_mid: node_mid,
          idValue: idValue,
          idType: parseInt(idType_id),
          country_id: parseInt(country_id),
          province_id: parseInt(province_id),
          city_id: parseInt(city_id),
          address_1: address_1,
          address_2: address_2,
          postalcode: parseInt(postalcode),
          create_user_table_id: sessionStorage.getItem("table_log_id"),
          create_user_id: sessionStorage.getItem("manage_user_id"),
          user_table_id: main_table_id,
          node_mid: this.props.state.mid,
          user_code:user_code
        };
        const teacherResponse = await TeacherService.create(
          JSON.stringify(teacherItem)
        );
        if (teacherResponse.success) {
          this.fetchAllTeachers();

          this.validator.purgeFields();
          this.validator.hideMessages();
          this.setState(this.formInitialState);

          try {
            this.setState({ isLoading: false, showInsertModal: false });
            sweetStatusAlert(
              "Success!",
              "Teacher added successfully..!",
              "success"
            );
          } catch (error) {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", "Failed to create new employee", "error");            
          }
          
        } else {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", teacherResponse.message, "error");
        }
      } catch (e) {
        this.setState({ isLoading: false });
        sweetStatusAlert("Failed!", "Failed to create new employee", "error");
      }
    }
  };

  //Handle Edit Submit
  handleEditSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      try {
        this.setState({ isLoading: true });
        const {
          session_adm_id,
          user_id,
          first_name,
          last_name,
          email,
          phone_number,
          dob,
          gender_id,
          role_code,
          created_on,
          created_by,
          status_id,
          node_mid,
          country_id,
          province_id,
          city_id,
          address_1,
          address_2,
          postalcode,
          is_lg_user,
          user_code,
          idType_id,
          idValue,
        } = this.state;

        const teacherItem = {
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone_number: parseInt(phone_number),
          dob: !!dob ? dob : null,
          gender_id: parseInt(gender_id),
          role_code: role_code,
          created_on: created_on === "" ? null : created_on,
          created_by: created_by,
          user_status_id: parseInt(status_id),
          node_mid: node_mid,
          country_id: parseInt(country_id),
          province_id: parseInt(province_id),
          idValue: idValue,
          idType: parseInt(idType_id),
          city_id: parseInt(city_id),
          address_1: address_1,
          address_2: address_2,
          postalcode: parseInt(postalcode),
          user_code:user_code
        };

        const teacherId = user_id;
        const teacherResponse = await TeacherService.update(
          teacherItem,
          teacherId
        );

        if (teacherResponse.success) {
          this.fetchAllTeachers();
          let usertype = sessionStorage.getItem("userType")
          if( "teacher" === usertype && !!is_lg_user){
            sessionStorage.setItem("username", first_name + " " + last_name);
            this.setState({
              user_name :first_name + " " + last_name
            })
          }
          this.setState({ isLoading: false, showModal: false });
          sweetStatusAlert(
            "Success!",
            "Employee information updated successfully..!",
            "success"
          );

          this.validator.purgeFields();
          this.validator.hideMessages();
          this.setState(this.formInitialState);
        } else {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", teacherResponse.message, "error");
        }
      } catch (e) {
        this.setState({ isLoading: false });
        sweetStatusAlert("Failed!", e, "error");
      }
    }
  };

  handleRoleEditSubmit = async (user_role_id, newRoleCode, user_id) => {
        try {
          this.setState({isPrivilegeModalLoading:true})
          const employeeUserRoleData = {
            user_role_id: parseInt(user_role_id),
            user_id: user_id,
            module: 'Manage ' + this.getRespectiveRoleCode(newRoleCode).role_code,
            role_code: this.getRespectiveRoleCode(newRoleCode).role_code
          };
          const roleResponse = await UserManagementService.updateStaffRole(
            employeeUserRoleData,
            this.state.privilegedTeacher?.user_id
          );
          if(!roleResponse.success){
            sweetStatusAlert("Failed", roleResponse.message.error, "error");   
          }else{
            await StaffService.searchStaffByTableAndUserIds(this.state.privilegedTeacher?.user_id, this.state.main_table_id).then((res) => {
              this.setState(() => ({
                assignedRoles:res.data,
              }))
            })
            this.loadInitialData();
            sweetStatusAlert("Success!",
            "Role updated successfully..!",
            "success"); 
          }
          this.setState({isPrivilegeModalLoading:false})
        } catch (e) {
          this.setState({isPrivilegeModalLoading:false})
          sweetStatusAlert("Failed!", e, "error");
        }
    };

  getRespectiveStatusTypeID(name) {
    const type = this.state.statusTypes.find((item) => item.name === name);
    return type ? type.type_id : "";
  }

  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find((role) => role.role_code === role_code);
    return roleData 
  }

  handleDeleteRoleCode  = async(teacherRole) => {
    try {
      this.setState({isPrivilegeModalLoading:true})
      await UserManagementService.deleteRoleCode(teacherRole.role_code, teacherRole.user_id)      
      await StaffService.searchStaffByTableAndUserIds(this.state.privilegedTeacher?.user_id, this.state.main_table_id).then((res) => {
        this.setState(() => ({
          assignedRoles:res.data,
        }))
      })   
      this.setState({isPrivilegeModalLoading:false})   
    } catch (error) {
      
    }
  }
  
  getRespectiveRoleCode(role_code) {
    const roleData = this.state.roles.find((role) => role.role_code === role_code);
    return roleData 
  }

  handleCreateRole = async () => {
    if(this.state.assignedRoles.length > 0){
      const teacherUserRoleData = {
        user_id:  this.state.assignedRoles[0].user_id,
        module: 'Manage '+ this.getRespectiveRoleCode(this.state.role_code).role_code,
        role_code: this.getRespectiveRoleCode(this.state.role_code).role_code
      };
      try {
        this.setState({isPrivilegeModalLoading:true})
        const result = await UserManagementService.createStaffRole(
          JSON.stringify(teacherUserRoleData)
        );  
        if(!result.success){
          sweetStatusAlert("Failed", result.message.error, "error");   
        }else{
          await StaffService.searchStaffByTableAndUserIds(this.state.privilegedTeacher?.user_id, this.state.main_table_id).then((res) => {
            this.setState(() => ({
              assignedRoles:res.data,
            }))
          })
        }
        this.setState({isPrivilegeModalLoading:false})
      } catch (error) {
        sweetStatusAlert("Failed", error, "error");        
      }
    }else{
      sweetStatusAlert("Failed", 'Cant able to Add Role', "error");
    }
  }
  
  // handleDeleteRole = async () => {
  //   const teacherUserRoleData = {
  //     user_id:  this.state.privilegedTeacher?.user_id,
  //     role_code: getRespectiveRoleCode(this.state.role_code).role_code
  //   };
  //   await UserManagementService.createStaffRole(
  //     JSON.stringify(teacherUserRoleData)
  //   );
  // }

  handleDeleteRoleCode  = async(teacherRole) => {
    try {
      this.setState({isPrivilegeModalLoading:true})
      await UserManagementService.deleteRoleCode(teacherRole.role_code, teacherRole.user_id)      
      await StaffService.searchStaffByTableAndUserIds(this.state.privilegedTeacher?.user_id, this.state.main_table_id).then((res) => {
        this.setState(() => ({
          assignedRoles:res.data
        }))
      })     
      this.setState({isPrivilegeModalLoading:false}) 
    } catch (error) {
      
    }
  }

  toggleAddTeacherModal = () => {
    this.setState(prevState => ({
      showInsertModal: !prevState.showInsertModal,
      first_name: "",
      last_name: "",
      dob: "",
      email: "",
      phone_number: "",
      gender_id: "",
      role_code_selected: "",
      status_id: "",
      created_on: "",
      created_by: "",
      address_1: "",
      address_2: "",
      city_id: "",
      province_id: "",
      postalcode: "",
      country_id: "",
    }), () => {
    });
  };

  toggleAddSeparateTeacherModal = () => {
    this.setState((prevState) => ({
      isAddTeacherModalOpen: !prevState.isAddTeacherModalOpen,
    }));
  };

  render() {
    const {
      isLoading,
      isModalLoading,
      countries,
      limit,
      teachers,
      totalTeachers,
      isTableDataLoading,
      currentPage,
      first_name,
      last_name,
      email,
      phone_number,
      dob,
      gender_id,
      role_code_selected,
      created_on,
      created_by,
      status_id,
      genders,
      employeeTypes,
      adm_statuses,
      editVisibility,
      deleteVisibility,
      country_id,
      province_id,
      city_id,
      address_1,
      address_2,
      postalcode,
      provinces,
      cities,
      user_name,
      breadcrumb2,
      nodeTitle,
      addVisibility,
      user_code,
      roles,
      role_code,
      assignedRoles,
      idTypes,
      idValue,
      idType_id,
    } = this.state;
    const path = history.location.pathname
    this.validator.purgeFields();
    let fromProfile = false
    if (this.props.state.path === 'profile') {
      fromProfile = true
    }

    return (
      <>
        <div style={{ overflow: "auto", height: "90vh" }}>
          <ContentWrapper disabled={path === "/manage-search"}>
            <Card>
              <CardHeader>
              <div className="manage-card-header">
                  <div>
                    {(this.props.state?.path !== 'node'  &&  !fromProfile) && <p className="py-4" style={{ color: "gray", fontSize: "10.5625px", color: "#00000099" }}>
                    {(breadcrumb2 || nodeTitle) ? `${breadcrumb2 &&breadcrumb2}${nodeTitle && nodeTitle}`: undefined}
                    </p>}
                    {!fromProfile && (<Form.Group
                    controlId="exampleForm.ControlInput1"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={this.handleSearch}
                      isInvalid={this.state.searchError}
                      className="manage-search-bar"
                    />
                    {this.state.searchError && (
                      <Form.Control.Feedback type="invalid">
                        Invalid input
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>)}
                  </div>
                  <div>
                    {addVisibility && !fromProfile && (
                      <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={this.toggleAddSeparateTeacherModal}
                        >
                          Add Employee
                        </Button>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
              {/* <Form.Group
                  controlId="exampleForm.ControlInput1"
                  className="mb-2"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.handleSearch}
                    isInvalid={this.state.searchError}
                    // style={{ width: "18%" }}
                    className="col-md-3 col-12"
                  />
                  {this.state.searchError && (
                    <Form.Control.Feedback type="invalid">
                      Invalid input
                    </Form.Control.Feedback>
                  )}
                </Form.Group> */}
                {isLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isModalLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading ? (
                  <div className="loading-container">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div className="manage-table-wrapper">
                    <Table>
                      <TableHead>
                        <TableRow>
                         {/* <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("adm_id")}
                          >
                            Admin ID{" "}
                            {this.state.sortColumn === "adm_id" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell> */}
                          <TableCell 
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("user_code")}
                            >
                            User Code{" "}
                            {this.state.sortColumn === "user_code" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("first_name")}
                          >
                            Name{" "}
                            {this.state.sortColumn === "first_name" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("email")}
                          >
                            Email{" "}
                            {this.state.sortColumn === "email" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.handleSortChange("phone_number")
                            }
                          >
                            Phone Number{" "}
                            {this.state.sortColumn === "phone_number" && (
                              <span>
                                {this.state.sortDirection === "asc"
                                  ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                  : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="thead">Status</TableCell>
                          <TableCell className="thead">Action</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {teachers?.map((teacherItem) => (
                          <TableRow key={teacherItem.user_id}>
                            {/* <TableCell className="tData">
                              {adminItem.adm_id}
                            </TableCell> */}
                            <TableCell className="tData">
                              {teacherItem.user_code}
                            </TableCell>
                            <TableCell className="tData">
                              {`${teacherItem.first_name || ""} ${teacherItem.last_name || ""}`.trim()}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.email}
                            </TableCell>
                            <TableCell className="tData">
                              {teacherItem.phone_number}
                            </TableCell>
                            {teacherItem.status ? (
                              <TableCell className="tData">
                                <span className="label label-lg label-light-success label-inline">
                                  {teacherItem.status}
                                </span>
                              </TableCell>
                            ) : (
                              <TableCell className="tData"></TableCell>
                            )}
                            <TableCell>
                              <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                <IconButton
                                  onClick={() => {
                                    history.push(routes.detailed_profile, {
                                      employee: teacherItem,
                                      teacher: teacherItem,
                                      student: teacherItem,
                                      isEmployee: true,
                                      manageState: this.props.state || {},
                                    });
                                  }}
                                  title="View Details"
                                >
                                  <VisibilityIcon
                                    style={{
                                      color: "#A2A5B5",
                                      fontSize: "20px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {!fromProfile && 
                    <MaterialCustomTablePagination
                        totalCount = {parseInt(totalTeachers)}
                        currentPage = {currentPage}
                        limit = {limit}
                        handlePageChange = {this.handlePageChange}
                        handleRowsPerPageChange = {this.handleRowsPerPageChange}
                        handlePageOffsetChange = {this.handlePageOffsetChange}
                        rowsPerPageOptions={[5, 10, 20]}
                        offset = {this.state.offset}
                    />}
                  </div>
                )}
              </CardBody>
            </Card>
          </ContentWrapper>

          <AddTeacherModal  state={this.props.state} isAddTeacherModalOpen = {this.state.isAddTeacherModalOpen} toggleAddTeacherModal={this.toggleAddSeparateTeacherModal} fetchAllTeachers={this.fetchAllTeachers}/>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() =>
              this.handleSweetAlert(this.toggleUpdateTeacherModal(this.state.privilegedTeacher), "showModal")
            }
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Employee Information</Modal.Title>
            </Modal.Header>
            <div>
              <Modal.Body>
                <Form>
                  <Row>
                    <Modal.Title className="pl-4 mb-4">
                      Personal Details
                    </Modal.Title>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>First Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={first_name}
                        placeholder="First Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "first_name",
                        first_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee first name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Last Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={last_name}
                        placeholder="Last Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "last_name",
                        last_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee last name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>ID Type*</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="idType_id"
                          value={idType_id}
                          onChange={this.handleChange}
                          defaultValue={""}
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          {!!idTypes.length &&
                            idTypes.map((idType) => (
                              <option
                                key={idType.idType_id}
                                value={idType.idType_id}
                              >
                                {idType.idType}
                              </option>
                            ))}
                    </Form.Select>
                        {this.validator.message(
                          "idType_id",
                          idType_id,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The ID Type is required.",
                            },
                          }
                        )}
                        {idType_id && <br />}
                    </Form.Group>
                    {idType_id && 
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>ID Value*</Form.Label>
                      <Form.Control
                        type="text"
                        name="idValue"
                        placeholder="ID Value"
                        value={idValue}
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "idValue",
                        idValue,
                        "required|min:9",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee ID value is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    }
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>DOB*</Form.Label>
                      <Form.Control
                        className="py-2"
                        type="date"
                        name="dob"
                        value={dob}
                        placeholder="Date of Birth"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "dob",
                        dob,
                        "required|dateBefore",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The date of birth is required.",
                          },
                        }
                      )}
                    </Form.Group>
                   
                    
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={email}
                        placeholder="example@gmail.com"
                        onChange={this.handleChange}
                        disabled
                      />
                      {/* {this.validator.message(
                        "email",
                        email,
                        "required|email",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The email is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="gender_id"
                        value={gender_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {genders?.map((gender) => (
                          <option
                            key={gender.gender_id}
                            value={gender.gender_id}
                          >
                            {gender.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "gender_id",
                        gender_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The gender is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                   
                  </Row>
                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Phone Number*</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone_number"
                        value={phone_number}
                        placeholder="Phone Number"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "phone_number",
                        phone_number,
                        "required|numeric|between:9,10|phone_number",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The phone number is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="status_id"
                        value={status_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {!!adm_statuses.length && adm_statuses.map((status) => (
                          <option
                            key={status.status_id}
                            value={status.status_id}
                          >
                            {status.name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "status_id",
                        status_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The status is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    
                  </Row>
                  
                  <Row className="my-5">
                    

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Employee ID Prefix</Form.Label>
                      <Form.Control
                        type="text"
                        name="user_code"
                        value={user_code?user_code:""}
                        placeholder="Employee ID"
                        disabled
                      />
                      {this.validator.message(
                        "user_code",
                        user_code,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee ID is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Employee Type*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="role_code"
                        value={role_code}
                        onChange={this.handleChange}
                        disabled={["DEOP", "MASAD", "TEACH"].includes(sessionStorage.getItem("employeeType"))}
                        className={["DEOP", "MASAD", "TEACH"].includes(sessionStorage.getItem("employeeType")) ? "bg-secondary text-black" : ""}
                      >
                        <option value="">Select</option>
                        {employeeTypes?.map((employee) => (
                          <option
                            key={employee.role_code}
                            value={employee.role_code}
                          >
                            {employee.role_name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "role_code",
                        role_code,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee type is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="pt-5">
                    <Modal.Title className="pl-4 mb-4">
                      Residential Details
                    </Modal.Title>
                  </Row>

                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Address Line 1</Form.Label>
                      <Form.Control
                        type="text"
                        name="address_1"
                        placeholder="Address 1"
                        onChange={this.handleChange}
                        value={address_1}
                      />
                      {/* {this.validator.message(
                        "address_1",
                        address_1,
                        "address|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Address 1 is required.",
                            address: "The address 1 must be a valid address",
                          },
                        }
                      )} */}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Address Line 2</Form.Label>
                      <Form.Control
                        type="text"
                        name="address_2"
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        value={address_2}
                      />
                      {/* {this.validator.message(
                        "address_2",
                        address_2,
                        "address|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Address 2 is required.",
                            address: "The address 2 must be a valid address",
                          },
                        }
                      )} */}
                    </Form.Group>
                    
                  </Row>
                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Country</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="country_id"
                        onChange={this.handleChange}
                        value={country_id}
                      >
                        <option value="">Select</option>
                        {countries?.map((country) => (
                          <option
                            value={country.country_id}
                            key={country.country_id}
                          >
                            {country.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "country_id",
                        country_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Country is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Province/District</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="province_id"
                        onChange={this.handleChange}
                        value={province_id}
                      >
                        <option value="">Select</option>
                        {provinces?.map((province) => (
                          <option
                            value={province.province_id}
                            key={province.province_id}
                          >
                            {province.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "province_id",
                        province_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Province is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                   
                  </Row>
                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>City</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="city_id"
                        onChange={this.handleChange}
                        value={city_id}
                      >
                        <option value="">Select</option>
                        {cities?.map((city) => (
                          <option value={city.city_id} key={city.city_id}>
                            {city.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message("city_id", city_id, "required", {
                        className: "text-danger",
                        messages: {
                          required: "The City is required.",
                        },
                      })} */}
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="postalcode"
                        placeholder="Postal Code"
                        onChange={this.handleChange}
                        value={postalcode}
                      />
                      {/* {this.validator.message(
                        "postalcode",
                        postalcode,
                        "numeric|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The postal code is required.",
                            numeric: "The postal code must be a number",
                          },
                        }
                      )} */}
                    </Form.Group>
                    
                   
                    
                  </Row>

                  <Modal.Footer>
                    <Button
                      className="modal-btn"
                      id="modal-close-button"
                      style={ closeBtnStyle }
                      onClick={() =>
                        this.handleSweetAlert(
                          this.toggleUpdateTeacherModal,
                          "showModal"
                        )
                      }
                    >
                      Close
                    </Button>
                    <Button
                      className="modal-btn"
                      variant="primary"
                      style={ addBtnStyle }
                      onClick={this.handleEditSubmit}
                    >
                      Save changes
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </div>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showInsertModal}
            onHide={() =>
              this.handleSweetAlert(
                this.toggleAddTeacherModal,
                "showInsertModal"
              )
            }
          >
            <Modal.Header closeButton>
              <Modal.Title>Create New Teacher</Modal.Title>
            </Modal.Header>
            <div>
              <Modal.Body>
                <Form>
                 
                <Row>
                    <Modal.Title className="pl-4 mb-4">
                      Personal Details
                    </Modal.Title>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>First Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={first_name}
                        placeholder="First Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "first_name",
                        first_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The student first name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Last Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={last_name}
                        placeholder="Last Name"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "last_name",
                        last_name,
                        "required|alpha_space|min:2|max:15",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The student last name is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>ID Value*</Form.Label>
                      <Form.Control
                        type="text"
                        name="idValue"
                        placeholder="ID Value"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "idValue",
                        idValue,
                        "required|min:9",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee ID Value is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>DOB</Form.Label>
                      <Form.Control
                        className="py-2"
                        type="date"
                        name="dob"
                        value={dob}
                        placeholder="Date of Birth"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "dob",
                        dob,
                        "dateBefore",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The date of birth is required.",
                          },
                        }
                      )}
                    </Form.Group>
                   
                    
                  </Row>
                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={email}
                        placeholder="example@gmail.com"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "email",
                        email,
                        "required|email",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The email is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="gender_id"
                        value={gender_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {genders?.map((gender) => (
                          <option
                            key={gender.gender_id}
                            value={gender.gender_id}
                          >
                            {gender.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "gender_id",
                        gender_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The gender is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                  </Row>
                 

                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Phone Number*</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone_number"
                        value={phone_number}
                        placeholder="Phone Number"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "phone_number",
                        phone_number,
                        "required|numeric|between:9,10|phone_number",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The phone number is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Status*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="status_id"
                        value={status_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {adm_statuses?.map((status) => (
                          <option
                            key={status.status_id}
                            value={status.status_id}
                          >
                            {status.name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "status_id",
                        status_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The status is required.",
                          },
                        }
                      )}
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Teacher ID Prefix</Form.Label>
                      <Form.Control
                        type="text"
                        name="user_code"
                        value={user_code?user_code:""}
                        placeholder="Teacher ID"
                        disabled
                      />
                      {this.validator.message(
                        "user_code",
                        user_code,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee ID is required.",
                          },
                        }
                      )}
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Employee Type*</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="role_code"
                        value={role_code}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {employeeTypes?.map((employee) => (
                          <option
                            key={employee.role_code}
                            value={employee.role_code}
                          >
                            {employee.role_name}
                          </option>
                        ))}
                      </Form.Select>
                      {this.validator.message(
                        "role_code",
                        role_code,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The employee id is required.",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="pt-5">
                    <Modal.Title className="pl-4 mb-4">
                      Residential Details
                    </Modal.Title>
                  </Row>

                  <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Address Line 1</Form.Label>
                      <Form.Control
                        type="text"
                        name="address_2"
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        value={address_2}
                      />
                      {/* {this.validator.message(
                        "address_2",
                        address_2,
                        "address|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Address 2 is required.",
                            address: "The address 2 must be a valid address",
                          },
                        }
                      )} */}
                    </Form.Group>   
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Address Line 2</Form.Label>
                      <Form.Control
                        type="text"
                        name="address_2"
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        value={address_2}
                      />
                      {/* {this.validator.message(
                        "address_2",
                        address_2,
                        "address|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Address 2 is required.",
                            address: "The address 2 must be a valid address",
                          },
                        }
                      )} */}
                    </Form.Group>
                    
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Label>Country</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="country_id"
                        onChange={this.handleChange}
                        value={country_id}
                      >
                        <option value="">Select</option>
                        {countries?.map((country) => (
                          <option
                            value={country.country_id}
                            key={country.country_id}
                          >
                            {country.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "country_id",
                        country_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Country is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Province/District</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="province_id"
                        onChange={this.handleChange}
                        value={province_id}
                      >
                        <option value="">Select</option>
                        {provinces?.map((province) => (
                          <option
                            value={province.province_id}
                            key={province.province_id}
                          >
                            {province.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message(
                        "province_id",
                        province_id,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The Province is required.",
                          },
                        }
                      )} */}
                    </Form.Group>
                  </Row>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>City</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="city_id"
                        onChange={this.handleChange}
                        value={city_id}
                      >
                        <option value="">Select</option>
                        {cities?.map((city) => (
                          <option value={city.city_id} key={city.city_id}>
                            {city.name}
                          </option>
                        ))}
                      </Form.Select>
                      {/* {this.validator.message("city_id", city_id, "required", {
                        className: "text-danger",
                        messages: {
                          required: "The City is required.",
                        },
                      })} */}
                    </Form.Group>                   
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="postalcode"
                        placeholder="Postal Code"
                        onChange={this.handleChange}
                        value={postalcode}
                      />
                      {/* {this.validator.message(
                        "postalcode",
                        postalcode,
                        "numeric|required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The postal code is required.",
                            numeric: "The postal code must be a number",
                          },
                        }
                      )} */}
                    </Form.Group>
                  </Row>

                  <Modal.Footer>
                    <Button
                      className="mb-4"
                      id="modal-close-button"
                      style={ closeBtnStyle }
                      onClick={() =>
                        this.handleSweetAlert(
                          this.toggleAddTeacherModal,
                          "showInsertModal"
                        )
                      }
                    >
                      Close
                    </Button>
                    <Button
                      className="mb-4"
                      variant="primary"
                      style={ addBtnStyle }
                      onClick={this.handleSubmit}
                    >
                      Save changes
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </div>
          </Modal>
          
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showPrivModel}
            onHide={this.togglePrivAddition}
          >
            <Modal.Header closeButton>
              <Modal.Title>Assign Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.isPrivilegeModalLoading ? (
                <div className="loading-container">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="thead">Module</TableCell>
                        <TableCell className="thead">Role Code</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {assignedRoles?.map((role, index) => (
                        <TableRow key={index}>
                          <TableCell className="tData">{role.module}</TableCell>
                          <TableCell className="tData">{role.role_code}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
              <Form>
                {!this.state.isPrivilegeModalLoading && editVisibility && assignedRoles.length === 2 && (
                  <Row className="my-5">
                    <Form.Group as={Col} md="10" controlId="exampleForm.ControlInput3">
                      <Form.Label>Role*</Form.Label>
                      <Form.Select
                        aria-label="Select Role"
                        name="role_code"
                        onChange={(e) => this.setState({ role_code: e.target.value })} // Update state when user selects a new role
                        value={this.state.role_code || assignedRoles[1]?.role_code || ""} // Use state first, then fallback to the assigned role
                        >
                        <option value="">Select</option>
                        {employeeTypes?.map((role) => (
                          <option value={role.role_code} key={role.role_code}>
                            {role.role_code}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                    <div className="d-flex align-items-end">
                      <Button style={addBtnStyle} 
                      onClick={() =>
                        this.handleRoleEditSubmit(
                          assignedRoles[1]?.user_role_id, 
                          this.state.role_code, 
                          assignedRoles[1]?.user_id
                        )
                      }
                      >
                        Update
                      </Button>
                    </div>
                  </Row>
                )}
                <Modal.Footer>
                  <Button
                    className="mb-4"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() => {
                      this.loadInitialData();
                      this.close();
                    }
                      }
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      </>
    );
  }
}
